import {
  GrowthModeModule,
  MonthlyBudgetModule,
  type Audience,
  type BudgetState,
} from "../../../../pages/Ads2DControlsAlphaBeta/shared";
import { ADS_SETTINGS_BODY_CLASS } from "../constants/layout";

import { AdsManagerContent } from "./AdsManagerContent";
import { AdTypeModule } from "./AdTypeModule";

type CoreSettingsTabProps = {
  growthIdx: number;
  onGrowthIdxChange: (idx: number) => void;
  budget: BudgetState;
  onBudgetChange: (next: Partial<BudgetState>) => void;
  audience: Audience;
  onAudienceChange: (value: Audience) => void;
  budgetConstrained?: boolean;
};

/** Core settings aligned with ads-2d-controls-alpha-beta (variant 1). */
export function CoreSettingsTab({
  growthIdx,
  onGrowthIdxChange,
  budget,
  onBudgetChange,
  audience,
  onAudienceChange,
  budgetConstrained = false,
}: CoreSettingsTabProps) {
  return (
    <AdsManagerContent className="py-8 pb-32">
      <div className={`${ADS_SETTINGS_BODY_CLASS} gap-6`}>
        <div>
          <h2 className="text-[22px] leading-[32px] font-medium text-[#333]">
            General settings
          </h2>
          <p className="mt-2 text-sm leading-5 text-[#333]">
            Your general settings determine which ad placements you&apos;re
            considered for and how hard we push to win them, based on who
            you&apos;re targeting and how much you&apos;re willing to spend.
          </p>
        </div>
        <GrowthModeModule
          variant="A"
          value={growthIdx}
          onChange={onGrowthIdxChange}
          headingLevel="h3"
        />
        <MonthlyBudgetModule
          budget={budget}
          onBudgetChange={onBudgetChange}
          growthMode={growthIdx}
          budgetConstrained={budgetConstrained}
          headingLevel="h3"
        />
        {/* This prototype's fork of TargetAudienceModule — see AdTypeModule. */}
        <AdTypeModule
          audience={audience}
          onAudienceChange={onAudienceChange}
          headingLevel="h3"
        />
      </div>
    </AdsManagerContent>
  );
}
